import React, { useContext } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button, Space, Tooltip } from 'antd';

import LogSyncContext from '@totem/components/administration/logSync/LogSyncContext';
import LogSyncTable from '@totem/components/administration/logSync/LogSyncTable';
import FiltersChipsContainer from '@totem/components/ui_components/filters/FilterChipsContainer';
import FilterChips from '@totem/components/ui_components/reportSettings/filterChips';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

export const LogSyncExtra = () => {
  const { totalRecords, onRefresh } = useContext(LogSyncContext);

  return (
    <Space>
      <RecordCountBadge count={totalRecords} />
      <Tooltip title="Refresh">
        <Button icon={<ReloadOutlined />} onClick={onRefresh} />
      </Tooltip>
    </Space>
  );
};

export const LogSyncLayout = () => (
  <>
    <FiltersChipsContainer>
      <FilterChips />
    </FiltersChipsContainer>
    <LogSyncTable />
  </>
);

export default LogSyncLayout;
